function selectLastComponentEditorVersion(state) {
  return state.component.data.lastEditorVersion ?? state.component.data.originalVersion;
}

export { selectLastComponentEditorVersion };
//# sourceMappingURL=data.last-editor-version.js.map
